import * as tslib_1 from "tslib";
import isConversationExpanded from './isConversationExpanded';
import { listViewStore } from 'owa-mail-list-store';
export default function isItemPartOperation(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    return (!tableView.isInCheckedMode &&
        tableView.selectedRowKeys.size == 1 &&
        isConversationExpanded(tslib_1.__spread(tableView.selectedRowKeys.keys())[0]));
}
//# sourceMappingURL=isItemPartCommandBarOperation.js.map